<template>
	<el-select
		v-bind="$attrs"
		v-model="userId"
		clearable
		filterable
		:placeholder="placeholder"
		:multiple="multiple"
		:collapse-tags="collapseTags"
		@change="change"
	>
		<el-option v-if="hasUnassigned" label="未归属" value="0" :class="{ 'footer-option': showIcon }">
			<div v-if="showIcon" style="float: left" class="flex">
				<div class="footer-img ml-6 mr-6">
					<yx-avatar></yx-avatar>
				</div>
				<div>
					<div>
						<span class="fz-14">未归属</span>
					</div>
					<p class="mt-2 yx-color-info fz-12">ID：-</p>
				</div>
			</div>
			<div v-else class="flex flex-align-center">
				<span class="mr-8">{{ item.name }}</span>
				<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
				<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
			</div>
		</el-option>
		<el-option v-for="item in optionList" :key="item.userId" :value="item.userId" :label="item.name" :class="{ 'footer-option': showIcon }">
			<div v-if="showIcon" style="float: left" class="flex">
				<div class="footer-img ml-6 mr-6">
					<yx-avatar :src="item.head"></yx-avatar>
				</div>
				<div>
					<div>
						<span class="fz-14">{{ item.name }}</span>
						<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
						<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini" class="ml-8">账号已停用</el-tag>
					</div>
					<p class="mt-2 yx-color-info fz-12">ID：{{ item.userId }}</p>
				</div>
			</div>
			<div v-else class="flex flex-align-center">
				<span class="mr-8">{{ item.name }}</span>
				<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
				<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
			</div>
		</el-option>
	</el-select>
</template>
<script>
import { commonList } from '@/api/cooperationProgress';
import { zsRoleType } from '@/utils/dataMap';
export default {
	name: 'DrPartnerSelect',
	props: {
		value: [String, Number, Array],
		placeholder: {
			type: String,
			default: `全部`,
		},
		showIcon: {
			type: Boolean,
			default: true,
		},
		onlyOnState: {
			type: Boolean,
			default: false,
		},
		customData: {
			type: Array,
			default: _ => [],
		},
		product_store_search: {
			type: Number,
			default: 0,
		}, //数据隔离的需求 在商品库页面传1进来 给后端进行区分
		collapseTags: {
			type: Boolean,
			default: false,
		}, // 是否开启 多选时是否将选中值按文字的形式展示
		multiple: {
			type: Boolean,
			default: false,
		}, // 是否多选
		// 是否有未归属
		hasUnassigned: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			userId: this.value,
			optionList: [],
		};
	},
	watch: {
		value(val) {
			this.userId = val;
		},
	},
	mounted() {
		this.getCommonList();
	},
	methods: {
		change(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
		async getCommonList() {
			const params = new Map([
				[false, { role_id: zsRoleType.id, all_status: 1, product_store_search: this.product_store_search }],
				[true, { role_id: zsRoleType.id, all_status: 0, product_store_search: this.product_store_search }],
			]);

			const { code, data } = await commonList(params.get(this.onlyOnState));
			if (code !== 0) return;
			this.optionList = [...this.customData, ...data];
			if (!this.onlyOnState) {
				// 将数组分成三个部分
				const notUseStatus2AndNotDeleted = this.optionList.filter(item => item.use_status !== '2' && !item.deleted);
				const useStatus2 = this.optionList.filter(item => item.use_status === '2');
				const deleted = this.optionList.filter(item => item.deleted);
				// 合并三个部分
				this.optionList = [...notUseStatus2AndNotDeleted, ...useStatus2, ...deleted];
			}
		},
	},
	components: {},
};
</script>
<style lang="less" scoped>
.footer-option {
	padding: 8px 0px;
	height: auto !important;
	line-height: initial;
}
.footer-img {
	img {
		width: 36px;
		height: 36px;
		border-radius: 50%;
	}
}
.all {
	height: 43px;
	padding-left: 46px;
	line-height: 43px;
}
</style>
